import React from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import styles from './ReactTooltip.module.scss';

/**
 * Global tooltip component for the entire application
 * 
 * Usage in components: 
 * 1. Add attributes to any element:
 *    - data-tooltip-id="global-tooltip" - required ID for linking to the tooltip
 *    - data-tooltip-content="Tooltip text" - tooltip content
 *    - data-tooltip-place="top|bottom|left|right" - optional, position (default: bottom)
 *    - data-tooltip-delay-show="500" - optional, delay in ms before showing
 *    - data-tooltip-offset="10" - optional, offset from the element in pixels
 * 
 * Example:
 * <button data-tooltip-id="global-tooltip" data-tooltip-content="Tooltip text">Hover me</button>
 */
const ReactTooltip = () => {
  return (
    <Tooltip 
      id="global-tooltip"
      place="bottom"
      variant="light"
      delayShow={150}
      style={{
        maxWidth: '250px',
        width: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        zIndex: 9999,
        lineHeight: '20px',
        fontSize: '13px',
        letterSpacing: '0',
      }}
      className={styles.tooltip}
    />
  );
};

export default ReactTooltip; 